/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Team_Plays_ItselfInputs */

const th_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทีมไม่สามารถแข่งกับตัวเองได้`)
};

const en_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A team cannot play itself.`)
};

const ja_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同じチーム同士で試合はできません。`)
};

const zh_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一支球队不能与自己比赛。`)
};

const es_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un equipo no puede jugar contra sí mismo.`)
};

const pt_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um time não pode jogar contra si mesmo.`)
};

const id_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebuah tim tidak bisa melawan dirinya sendiri.`)
};

const fr_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une équipe ne peut pas jouer contre elle-même.`)
};

const tl_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi maaaring laruin ng isang team ang sarili nito.`)
};

const vi_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Một đội không thể gặp chính mình.`)
};

const ko_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팀이 자기 자신과 경기할 수는 없습니다.`)
};

const de_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Team kann nicht gegen sich selbst spielen.`)
};

const ru_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команда не может играть сама с собой.`)
};

const tr_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir takım kendisiyle oynayamaz.`)
};

const it_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una squadra non può giocare contro sé stessa.`)
};

const pl_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drużyna nie może grać sama ze sobą.`)
};

const uk_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команда не може грати сама з собою.`)
};

const hi_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई टीम अपने ही ख़िलाफ़ नहीं खेल सकती।`)
};

const ar_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يمكن لفريق أن يلعب ضد نفسه.`)
};

const ms_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebuah pasukan tidak boleh bermain menentang dirinya sendiri.`)
};

const bn_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোনও দল নিজের বিরুদ্ধে খেলতে পারে না।`)
};

const zh_tw2_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球隊不能和自己比賽。`)
};

const zh_hk2_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球隊不能和自己比賽。`)
};

const ur_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کوئی ٹیم اپنے ہی خلاف نہیں کھیل سکتی۔`)
};

const fa_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یک تیم نمی‌تواند با خودش بازی کند.`)
};

const sw_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timu haiwezi kucheza dhidi yake yenyewe.`)
};

const nl_err_team_plays_itself = /** @type {(inputs: Err_Team_Plays_ItselfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een team kan niet tegen zichzelf spelen.`)
};

/**
* | output |
* | --- |
* | "A team cannot play itself." |
*
* @param {Err_Team_Plays_ItselfInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_team_plays_itself = /** @type {((inputs?: Err_Team_Plays_ItselfInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Team_Plays_ItselfInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_team_plays_itself(inputs)
	if (locale === "ja") return ja_err_team_plays_itself(inputs)
	if (locale === "zh") return zh_err_team_plays_itself(inputs)
	if (locale === "es") return es_err_team_plays_itself(inputs)
	if (locale === "pt") return pt_err_team_plays_itself(inputs)
	if (locale === "id") return id_err_team_plays_itself(inputs)
	if (locale === "fr") return fr_err_team_plays_itself(inputs)
	if (locale === "tl") return tl_err_team_plays_itself(inputs)
	if (locale === "vi") return vi_err_team_plays_itself(inputs)
	if (locale === "ko") return ko_err_team_plays_itself(inputs)
	if (locale === "de") return de_err_team_plays_itself(inputs)
	if (locale === "ru") return ru_err_team_plays_itself(inputs)
	if (locale === "tr") return tr_err_team_plays_itself(inputs)
	if (locale === "it") return it_err_team_plays_itself(inputs)
	if (locale === "pl") return pl_err_team_plays_itself(inputs)
	if (locale === "uk") return uk_err_team_plays_itself(inputs)
	if (locale === "hi") return hi_err_team_plays_itself(inputs)
	if (locale === "ar") return ar_err_team_plays_itself(inputs)
	if (locale === "ms") return ms_err_team_plays_itself(inputs)
	if (locale === "bn") return bn_err_team_plays_itself(inputs)
	if (locale === "zh-TW") return zh_tw2_err_team_plays_itself(inputs)
	if (locale === "zh-HK") return zh_hk2_err_team_plays_itself(inputs)
	if (locale === "ur") return ur_err_team_plays_itself(inputs)
	if (locale === "fa") return fa_err_team_plays_itself(inputs)
	if (locale === "sw") return sw_err_team_plays_itself(inputs)
	if (locale === "nl") return nl_err_team_plays_itself(inputs)
	return en_err_team_plays_itself(inputs)
});